import { global } from './lib/utils/globals';
global.probe = {};
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/init.js
// module id = 1634
// module chunks = 0